<template>
  <div>
    <p class="description">検索ワード履歴から検索を行えます。</p>
    <ul class="searchWords">
      <SearchHistoryRow v-for="(searchWord, index) in searchWords"
                        :searchWord="searchWord" :key="index"
                        @search="search" @remove="remove"
      ></SearchHistoryRow>
    </ul>
  </div>
</template>

<script>
  import SearchHistoryRow from './SearchHistoryRow';
  export default {
    name: 'SearchHistory',
    components: {SearchHistoryRow},
    data() {
      return {
        searchWords: [],
      };
    },
    created () {
      this.initialize();
    },
    methods: {
      initialize () {
        let searchWords = localStorage.getItem('searchWords');
        if (searchWords) this.searchWords = JSON.parse(searchWords).reverse();
      },
      search(searchWord) {
        this.$router.push({'path': `/search_result/${searchWord[0]}/`}, ()=>{});
      },
      remove(searchWord) {
        this.searchWords.splice(this.searchWords.indexOf(searchWord), 1);
        localStorage.setItem('searchWords', JSON.stringify(this.searchWords));
      },
    },
  };
</script>

<style scoped lang="scss">
  ul.searchWords {
    padding: 0;
    border-top: 2px solid gray;
    li {
      position: relative;
      list-style-type: none !important;
      line-height: 1.5;
      vertical-align: middle;
      border-bottom: 2px solid silver;
      height: 60px;
    }
  }

  p.description {
    padding: 1rem .6rem;
    margin: 0;
  }
</style>
